import { ChatMessage, CopilotResponse, UserCareerRole } from '@careerhub/api';
import { ICareerHubModuleState } from '../../models';
import { IActionWithParam, LoadingStates } from '../common.types';
import { CopilotState } from '../StoreConstants';
import { CopilotActionType } from './actions';
import { ICopilotState } from './types';
import { v4 } from 'uuid';

export const getInitialCopilotState = (): ICopilotState => ({
  messages: [],
  followupQuestions: [],
  loadingState: LoadingStates.NOT_STARTED,
  sessionId: v4(),
  conversationId: v4(),
  userContext: undefined,
});

export const copilotStateSelector = (state: ICareerHubModuleState): ICopilotState =>
  state[CopilotState] ?? getInitialCopilotState();

export function copilotStateReducer(
  prev: ICopilotState = getInitialCopilotState(),
  action: IActionWithParam<ChatMessage | CopilotResponse | UserCareerRole>
): ICopilotState {
  switch (action.type) {
    case CopilotActionType.RECEIVE_MESSAGE:
      const response: CopilotResponse = action.param as CopilotResponse;
      return {
        ...prev,
        messages: [...prev.messages, response],
        followupQuestions: response.followupQuestions?.split(';') ?? prev.followupQuestions,
        loadingState: LoadingStates.SUCCEEDED,
        sessionId: prev.sessionId,
        conversationId: prev.conversationId,
      };
    case CopilotActionType.SEND_MESSAGE: {
      const message: ChatMessage = action.param as ChatMessage;
      return {
        ...prev,
        messages: [...prev.messages, message],
        loadingState: LoadingStates.STARTED,
        sessionId: prev.sessionId,
        conversationId: prev.conversationId,
      };
    }
    case CopilotActionType.START_OVER: {
      return {
        ...prev,
        messages: [],
        followupQuestions: [],
        loadingState: LoadingStates.NOT_STARTED,
        sessionId: prev.sessionId,
        conversationId: v4(),
      };
    }
    case CopilotActionType.STOP_GENERATING: {
      return {
        ...prev,
        messages: [...prev.messages],
        followupQuestions: [],
        loadingState: LoadingStates.NOT_STARTED,
        sessionId: prev.sessionId,
        conversationId: prev.conversationId,
      };
    }
    case CopilotActionType.SET_USER_INFO: {
      const userDetails: UserCareerRole = action.param as UserCareerRole;
      return {
        ...prev,
        userContext: userDetails,
      };
    }
    default:
      return prev;
  }
}
